module.exports = __webpack_public_path__ + "static/media/T14-T25-12.e0c3be74.svg";